export const isSearchingInUsersSelector = (state) => state.searchInUsers.isUserSearching
export const usersFoundSelector = (state) => state.searchInUsers.usersFound
